import styled from 'styled-components'

export const ImgNot = styled.img`
  height: 60vh;
  width: 30vw;
`

export const Div = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin: 20px;
  padding: 10px;
`
